import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { firstValueFrom } from 'rxjs';
import { BackendAuthService } from './backend-auth.service';
import { SessionService } from './session.service';
import { FuncionarioEvaluado } from '@models/funcionario.interface';
import { DangerError } from '@shared/errors/custom.error';

@Injectable({
  providedIn: 'root'
})
export class FuncionarioService {

  constructor(private http: HttpClient, private authService: BackendAuthService, private sessionService: SessionService) { }

  async obtenerFuncionario(rut: string): Promise<FuncionarioEvaluado> {
    const tokenRes = await this.authService.obtenerToken();
    const token = tokenRes.access_token;
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}`, 'session_id': this.sessionService.getToken() || '' });
    const url = `${environment.backendUrl}/esi-funcionario-evaluado?rut=${rut}`;
    
    const { data, success } = await firstValueFrom(this.http.post<{ success: string, data: FuncionarioEvaluado }>(url, {}, { headers }));

    if (success !== 'true') {
        throw new DangerError('No se pudo obtener el funcionario');
    }
    
    return data;
  }
}
